var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9987 9.33325C2.36689 9.33325 2.66536 9.63173 2.66536 9.99992V12.6666C2.66536 12.8434 2.7356 13.013 2.86063 13.138C2.98565 13.263 3.15522 13.3333 3.33203 13.3333H12.6654C12.8422 13.3333 13.0117 13.263 13.1368 13.138C13.2618 13.013 13.332 12.8434 13.332 12.6666V9.99992C13.332 9.63173 13.6305 9.33325 13.9987 9.33325C14.3669 9.33325 14.6654 9.63173 14.6654 9.99992V12.6666C14.6654 13.197 14.4547 13.7057 14.0796 14.0808C13.7045 14.4559 13.1958 14.6666 12.6654 14.6666H3.33203C2.8016 14.6666 2.29289 14.4559 1.91782 14.0808C1.54274 13.7057 1.33203 13.197 1.33203 12.6666V9.99992C1.33203 9.63173 1.63051 9.33325 1.9987 9.33325Z",
    fill: "#8927EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19526 6.19526C4.45561 5.93491 4.87772 5.93491 5.13807 6.19526L8 9.05719L10.8619 6.19526C11.1223 5.93491 11.5444 5.93491 11.8047 6.19526C12.0651 6.45561 12.0651 6.87772 11.8047 7.13807L8.4714 10.4714C8.21106 10.7318 7.78894 10.7318 7.5286 10.4714L4.19526 7.13807C3.93491 6.87772 3.93491 6.45561 4.19526 6.19526Z",
    fill: "#8927EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9987 1.33325C8.36689 1.33325 8.66536 1.63173 8.66536 1.99992V9.99992C8.66536 10.3681 8.36689 10.6666 7.9987 10.6666C7.63051 10.6666 7.33203 10.3681 7.33203 9.99992V1.99992C7.33203 1.63173 7.63051 1.33325 7.9987 1.33325Z",
    fill: "#8927EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.b2ae82d89a5585455711d21c3b7ce417.svg";
export { ForwardRef as ReactComponent };